import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=5a276b4b&scoped=true&"
import script from "./Headline.vue?vue&type=script&lang=ts&"
export * from "./Headline.vue?vue&type=script&lang=ts&"
import style0 from "./Headline.vue?vue&type=style&index=0&id=5a276b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a276b4b",
  null
  
)

export default component.exports